export class DateFormat {
    format: string;
    length: number;

    constructor() {
        this.format = '%Y-%m-%d';
        this.length = 10;
    }
}